import { motion } from "framer-motion";
import { Users, ShieldCheck } from "lucide-react";

const panels = [
  {
    id: "culture-panel",
    icon: Users,
    label: "Culture & Community",
    title: "The people who power our mission",
    desc: "We value the people who power our mission. Our employees deliver meaningful solutions for customers and actively support their communities, guided by integrity and a commitment to making a lasting difference.",
  },
  {
    id: "ethics-panel",
    icon: ShieldCheck,
    label: "Ethics & Integrity",
    title: "Integrity at every level",
    desc: "Integrity guides how we operate — every day, at every level of the company. Our ethics program combines clear standards, ongoing training, and strong oversight to ensure we meet the highest expectations of our customers, partners, and employees.",
  },
];

export const CultureEthics = () => (
  <section id="culture" data-testid="culture-section" className="py-24 md:py-32 px-6 md:px-12 border-t border-black/10">
    <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8">
      {panels.map((p, i) => (
        <motion.div
          key={p.id}
          data-testid={p.id}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ type: "spring", stiffness: 60, damping: 18, delay: i * 0.12 }}
          className="bg-[#D4D4D8] border border-black/10 p-8 md:p-12 hover:border-black/30 transition-colors"
        >
          <p.icon size={28} className="text-[#0891B2] mb-8" />
          <p className="font-mono text-sm uppercase tracking-[0.2em] text-zinc-500 mb-3">{p.label}</p>
          <h3 className="text-3xl sm:text-4xl font-heading font-bold tracking-tight text-zinc-950">{p.title}</h3>
          <p className="mt-4 text-[19px] leading-relaxed text-zinc-600">{p.desc}</p>
        </motion.div>
      ))}
    </div>
  </section>
);
